import React from 'react';
import { css } from 'twin.macro';

const BGC_QUICK_FILTERS = [
    { label: 'BACKGROUND-CHECK', color: '#3b82f6' },
    { label: 'MONTHLY-AUDIT', color: '#8b5cf6' },
];

const DocumentQuickTagFilterPills = ({ tagFilterValues, onQuickFilter, onClearAll }) => {
    return (
        <div
            css={css`
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 10px;
                flex-wrap: wrap;
            `}
        >
            <span
                css={css`
                    font-size: 1rem;
                    color: #6b7280;
                    font-weight: 600;
                    white-space: nowrap;
                `}
            >
                Quick filter:
            </span>
            {BGC_QUICK_FILTERS.map(({ label, color }) => {
                const isActive = tagFilterValues?.some((t) => t.label === label);
                return (
                    <button
                        key={label}
                        onClick={() => onQuickFilter(label)}
                        css={css`
                            border: 1.5px solid ${color};
                            background: ${isActive ? color : 'transparent'};
                            color: ${isActive ? '#fff' : color};
                            border-radius: 999px;
                            padding: 2px 12px;
                            font-size: 1rem;
                            font-weight: 600;
                            cursor: pointer;
                            transition: all 0.15s;
                            letter-spacing: 0.02em;
                            &:hover {
                                background: ${color};
                                color: #fff;
                            }
                        `}
                    >
                        {label}
                    </button>
                );
            })}
            {tagFilterValues?.length > 0 && (
                <button
                    onClick={onClearAll}
                    css={css`
                        border: none;
                        background: none;
                        color: #9ca3af;
                        font-size: 1rem;
                        cursor: pointer;
                        padding: 2px 6px;
                        &:hover {
                            color: #ef4444;
                        }
                    `}
                >
                    ✕ clear
                </button>
            )}
        </div>
    );
};

export default DocumentQuickTagFilterPills;
